<h4 class="content-block ap-green">CRM Batch Reports</h4>


<app-batch-reports-grid [reportType]="'CRM Report'" (batchGridEvent)="onBatchGridEvent($event)"></app-batch-reports-grid>

<div style="margin-top: 20px;"></div>
<hr style="height:2px;border-width:0;color:gray;background-color:gray; width: 100%" *ngIf="showTabPanel">
<div style="margin-top: 20px;"></div>

<div *ngIf="showTabPanel">
    <ng-container #tabOutlet *ngTemplateOutlet="tabTemplate"></ng-container>
</div>
<ng-template #tabTemplate>
    <dx-tab-panel
        #crmBatchTabPanel
        [height]="inherit"
        [selectedIndex]="0"                
        [loop]="false"
        [deferRendering]="false"
        [animationEnabled]="false"        
        [swipeEnabled]="false"       
        [visible]="true">
        
        <dxi-item [title]="title1">
            <app-crm-report-datagrid 
                [jobID]="jobID1" 
                [reportType]="reportType1"
                (dataGridCreated)="onDataGridCreated($event)">
            </app-crm-report-datagrid>  
        </dxi-item>  

        <dxi-item [title]="title2" *ngIf="reportList.length > 1">
            <app-crm-report-datagrid 
                [jobID]="jobID2" 
                [reportType]="reportType2"
                (dataGridCreated)="onDataGridCreated($event)">
            </app-crm-report-datagrid>  
        </dxi-item>
        
    </dx-tab-panel>
</ng-template>
